// Provincias españolas (ordenadas alfabéticamente)
export const SPANISH_PROVINCES = [
  "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila",
  "Badajoz", "Baleares", "Barcelona", "Burgos", "Cáceres", "Cádiz",
  "Cantabria", "Castellón", "Ceuta", "Ciudad Real", "Córdoba", "Cuenca",
  "Girona", "Granada", "Guadalajara", "Gipuzkoa", "Huelva", "Huesca",
  "Jaén", "La Coruña", "La Rioja", "Las Palmas", "León", "Lleida",
  "Lugo", "Madrid", "Málaga", "Melilla", "Murcia", "Navarra",
  "Ourense", "Palencia", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife",
  "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo",
  "Valencia", "Valladolid", "Vizcaya", "Zamora", "Zaragoza",
];

export const LEAD_SOURCE_OPTIONS = [
  { value: "tram", label: "Tranvía / metro" },
  { value: "flyers", label: "Flyers" },
  { value: "rrss", label: "Redes sociales" },
  { value: "boca_a_boca", label: "Boca a boca" },
  { value: "calle", label: "Calle" },
  { value: "web", label: "Web" },
  { value: "otro", label: "Otro" },
];

export const CONTACT_CHANNELS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "call", label: "Llamada" },
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS" },
  { value: "otro", label: "Otro" },
];

export const CONTACT_RESULTS = [
  { value: "no_answer", label: "No contesta" },
  { value: "callback", label: "Volver a llamar" },
  { value: "scheduled", label: "Cita programada" },
  { value: "done", label: "Realizado / interesado" },
  { value: "not_interested", label: "No interesado" },
  { value: "otro", label: "Otro" },
];
